import { config } from '@app/config';

export const fromPublic = (pathInPublicFolder: string): string => {
  return (config.staticAssetsUrl || '') + pathInPublicFolder;
};
